import { DistUrl } from './BootstrapContext';

/* eslint-disable */
declare var __webpack_public_path__: string;

//Not a global variable. Webpack rewrites this expression to __webpack_require__.p = '...';
__webpack_public_path__ = DistUrl;
